/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, nthChildIterator, mediaQuery, disable } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : EMBED LIBRARY : STYLES --------------- ++++++++++ */
export default theme => ({
	library: {
		width: '100%',

		// ..... ROW GROUPS ..... //
		'& .libraryelement': {
			position: 'relative',
        	textAlign: 'left',
			'&.library-controls': {
				zIndex: '2',
				opacity: '0',
				animationName: 'fadeInUp',
                animationDuration: '.2s',
                animationFillMode: 'forwards',
                animationDelay: '.2s',
				'& .name-nameTitle':{
					'& .selected':{
						fontSize: pxToEm(14)
					}
				}
			},
			'&.library-content': {
				zIndex: '1',
				'& .title.name-numberof': {
					opacity: '0',
					animationName: 'fadeInUp',
					animationDelay: '.3s',
					animationDuration: '.2s',
					animationFillMode: 'forwards'
				}
			}
		},

		// ..... EMBEDS ..... //
		'& .embeds': {
			width: '100%',
			// overflow: 'hidden',
			display: 'flex',
			flexWrap: 'wrap',
			alignItems: 'flex-start', // stretch
			justifyContent: 'flex-start',
			'& .embedcard': {
				marginRight: '0.65%',
				marginLeft: '0.65%',
				marginBottom: pxToEm(20),
				width: '32%',
				transition: 'all .2s linear 0s',

				// animate in
				opacity: '0',
				animationName: 'fadeInUp',
                animationDuration: '.2s',
                animationFillMode: 'forwards',
				extend: nthChildIterator(100, .3, .05),
			},
			'& .newembed': {
				// animate in
				opacity: '0',
				animationName: 'fadeInUp',
                animationDuration: '.2s',
                animationDelay: '.25s',
                animationFillMode: 'forwards',

				cursor: 'pointer',
				background: '#FAFBFC',
				borderRadius: pxToEm(5),
				border: replacePXinStringWithEM(`3px dashed #ECF0F7`),
				minWidth: pxToEm(150),
				width: '32%',
				marginRight: '0.65%',
				marginLeft: '0.65%',
				marginBottom: pxToEm(20),
				minHeight: pxToEm(350),
				display: 'flex',
				flexDirection: 'column',
				alignContent: 'center',
				alignItems: 'center',
				justifyContent: 'center',
				transition: 'all .2s linear 0s',
				alignSelf: 'stretch',
				'& .icon': {
					color: 'rgba(6, 43, 117, 0.5)',
					fontSize: '250%'
				},
				'& .text': {
					color: 'rgba(6, 43, 117, 0.5)',
					fontSize: pxToEm(16)
				},
                '&.disabled-true':{
                    extend: disable,
                    filter: `grayscale(1) opacity(0.45)`
                },
				'&:hover': {
					filter: 'brightness(95%)'
				}
			}
		}
	},

	[mediaQuery.thinnest]: { 
		library: {
			'& .embeds': {
				'& .embedcard, .newembed': {
					width: '100%',
					marginRight: '0 !important',
					height: pxToEm(350)
				}
			}
		}
	}
});
